import React, { useEffect } from "react";
import { useAuth } from "../services/AuthContext";

// Loading component
const LoadingSpinner = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '18px'
  }}>
    <div>Authenticating...</div>
  </div>
);

// Protected route component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, login } = useAuth();

  useEffect(() => {
    // Automatically trigger login if not authenticated
    if (!loading && !isAuthenticated) {
      login();
    }
  }, [loading, isAuthenticated, login]);

  if (loading || !isAuthenticated) {
    return <LoadingSpinner />;
  }

  return children;
};

export default ProtectedRoute;